module.exports = __webpack_public_path__ + "static/media/3.cf397d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/3.png
// module id = 2070
// module chunks = 0